import { get } from "lodash";
import { FlatRoomTypeEnum } from "../../enum/flat-room-type.enum";

export class FinancialCalculator {
  flatType?: FlatRoomTypeEnum;
  isThereOutstandingLoan?: boolean;
  isThereNewLoan?: boolean;

  constructor(initial?: Partial<FinancialCalculator>) {
    this.flatType = get(initial, "flatType", undefined);
    this.isThereOutstandingLoan = get(initial, "isThereOutstandingLoan", undefined);
    this.isThereNewLoan = get(initial, "isThereNewLoan", undefined);
  }
}
